// extracted by mini-css-extract-plugin
export default {"login-page":"style_login-page__3KpRG","auth-form-wrapper":"style_auth-form-wrapper__v8TCd"};